import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Dialog, DialogContent } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';

const DeleteUserConfirmationDialog = ({
  open,
  userName,
  userEmail,
  isDeleting,
  onCancel,
  onConfirm,
}) => {
  const displayName =
    (typeof userName === 'string' && userName.trim()) ||
    (typeof userEmail === 'string' && userEmail.trim()) ||
    '';

  const handleClose = () => {
    if (!isDeleting) {
      onCancel();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className="delete-user-dialog"
      PaperProps={{ className: 'delete-user-dialog__paper' }}
      BackdropProps={{ className: 'delete-user-dialog__backdrop' }}
      aria-labelledby="delete-user-dialog-title"
    >
      <DialogContent className="delete-user-dialog__content">
        <div className="delete-user-dialog__icon">
          <DeleteOutlineIcon />
        </div>

        <div className="delete-user-dialog__body">
          <span className="delete-user-dialog__eyebrow">Eliminar usuario</span>
          <h2 id="delete-user-dialog-title">Confirmar eliminación</h2>
          <p>
            ¿Estás seguro que deseas eliminar
            {displayName ? ` a ${displayName}` : ' este usuario'}?
          </p>
        </div>

        {isDeleting && (
          <div className="delete-user-dialog__loading">
            <CircularProgress size={18} />
            <span>Eliminando usuario...</span>
          </div>
        )}

        <div className="delete-user-dialog__warning">
          <WarningRoundedIcon />
          <span>Esta acción puede tardar unos segundos.</span>
        </div>

        <div className="delete-user-dialog__actions">
          <button
            type="button"
            className="delete-user-dialog__button delete-user-dialog__button--secondary"
            onClick={handleClose}
            disabled={isDeleting}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="delete-user-dialog__button delete-user-dialog__button--danger"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <CircularProgress size={16} />
                Eliminando
              </>
            ) : (
              'Eliminar usuario'
            )}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

DeleteUserConfirmationDialog.defaultProps = {
  userName: '',
  userEmail: '',
};

DeleteUserConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  userName: PropTypes.string,
  userEmail: PropTypes.string,
  isDeleting: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteUserConfirmationDialog;
